export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],
        "abbr": ["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."]
      },
      "days": {
        "full": ["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],
        "abbr": ["dim.","lun.","mar.","mer.","jeu.","ven.","sam."]
      },
      "patterns": {
        "longDate": "dddd D MMMM YYYY",
        "dateSlash": "DD/MM/YYYY",
        "dateShort": "dddd D MMMM",
        "dateMedium": "dddd D MMMM - H[h]mm",
        "dateLarge": "D MMM YYYY [à] HH[:]mm[:]ss",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"]
      },
      "group": {
        "separator": " ",
        "length": 3,
        "abbr": ["", "k", "M", "Md"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function (number) { return number + (number === 1 ? 'er' : 'e'); }
    }
  },
  "translations": {
    messages: {
  " CASH ": [
    null,
    " CASH "
  ],
  "!action:Deposit": [
    null,
    "Je dépose"
  ],
  "!desc:BetRefundOffer": [
    null,
    "Le double du premier dépôt offert, jusqu’à 200 €<br /><br />Pour fêter votre arrivée sur Winamax, vous bénéficierez de deux offres de bienvenue lors de votre premier dépôt : un bonus allant jusqu’à 250 € et le double de votre premier dépôt offert en Freebets, jusqu’à 200 €* ! Vous pourrez ainsi commencez à parier sur le sport immédiatement.<br /><br />Les 2 offres sont cumulables et automatiquement déclenchées lors de votre premier dépôt, si vous en faites le choix."
  ],
  "!desc:BetRefundOffer100": [
    null,
    "Le premier dépôt offert, jusqu’à 100 €<br /><br />Pour fêter votre arrivée sur Winamax, vous bénéficierez de deux offres de bienvenue lors de votre premier dépôt : un bonus allant jusqu’à 250 € et le montant de votre premier dépôt offert en Freebets, jusqu’à 100 €* ! Vous pourrez ainsi commencez à parier sur le sport immédiatement.<br /><br />Les 2 offres sont cumulables et automatiquement déclenchées lors de votre premier dépôt, si vous en faites le choix."
  ],
  "!desc:CondBetRefundOffer": [
    null,
    "* Avant tout retrait, le montant du dépôt initial devra être misé en paris sportifs sur Winamax.fr (dans la limite de 100 € si celui-ci est supérieur) avec votre solde d'argent réel. Cette action peut se faire en plaçant un ou plusieurs paris (hors Freebets). Les paris annulés et les paris Cashout ne sont pas pris en compte."
  ],
  "!desc:CondFirstDeposit": [
    null,
    "* L'offre de premier dépôt n’est valable qu’une seule fois par utilisateur, terminal (ordinateur, tablette ou mobile), foyer, carte ou compte bancaire. Elle est réservée aux joueurs n’ayant jamais effectué de dépôt sur un compte Winamax (y compris sur un compte qui a été fermé depuis)"
  ],
  "!desc:DefaultLandingContent": [
    null,
    "<div class=\"hide-for-small\">\n<h2> Offre de bienvenue exceptionnelle </h2>\n<p> Pour fêter votre inscription sur Winamax, bénéficiez de deux offres exclusives de bienvenue : </p><ul><li>- Votre 1er pari remboursé <b>en cash dans la limite de 100 €</b> s’il est perdant</li><li>- Un bonus supplémentaire <b>pouvant atteindre 250 €</b></li></ul>\n<p>Les 2 offres sont cumulables et automatiquement déclenchées lors de votre premier dépôt*. </p><br />\n<p><font size='-2'><i>\n*<a href='https://www.winamax.fr/offre_bienvenue'> Voir toutes les conditions</a></i>\n</div>\n"
  ],
  "!desc:DefaultLandingContentES": [
    null,
    ""
  ],
  "!desc:DefaultLandingMobileContent": [
    null,
    "<h2> Offre de bienvenue exceptionnelle </h2>\n<p> Pour fêter votre inscription sur Winamax, bénéficiez de deux offres exclusives de bienvenue : </p><ul><li>- Votre 1er pari remboursé <b>en cash dans la limite de 100 €</b> s’il est perdant</li><li>- Un bonus supplémentaire <b>pouvant atteindre 250 €</b></li></ul>\n<p>Les 2 offres sont cumulables et automatiquement déclenchées lors de votre premier dépôt*. </p><br />\n<p><font size='-2'><i>\n*<a href='https://www.winamax.fr/offre_bienvenue'> Voir toutes les conditions</a></i>\n"
  ],
  "!desc:DefaultLandingPageTitleES": [
    null,
    ""
  ],
  "!desc:DefaultLandingTitleES": [
    null,
    ""
  ],
  "!desc:SpecialOfferLandingContent": [
    null,
    "<div class=\"hide-for-small\">\n<p>Pour fêter votre arrivée sur Winamax, profitez de deux offres de bienvenue lors de votre 1er dépôt : <b>le double de votre premier dépôt en Freebets jusqu’à 200 €</b> ! Ainsi qu'un <b>bonus allant jusqu'à 250 €</b>*.</p><br />\n\n<p>Les 2 offres sont cumulables et automatiquement déclenchées lors de votre premier dépôt, si vous en faites le choix.</p><br />\n\n<p>Alors, qu’attendez-vous pour rejoindre le site qui propose <b>le meilleur bonus de bienvenue ?</b></p><br />\n\n<h2>Comment ça marche ?</h2>\n<br />\n<p>Lors de votre tout premier dépôt sur Winamax, et avant n'importe quelle action de jeu, on vous offre le double de votre dépôt en Freebets jusqu’à 200 €.</p>\n\n<p>Par exemple, si vous déposez 100 € sur Winamax, vous recevrez immédiatement 200 € de Freebets sur votre compte et pourrez commencer à parier sur les différents sports. Les gains nets issus de Freebets sont versés en cash sur votre compte.</p>\n<br />\n<p>Nous vous offrons également un bonus d'une valeur égale à votre dépôt, dans la limite de 250 €. Nous créditerons votre compte Winamax par tranche de 20% de la valeur du bonus dès que vous aurez cumulé assez de Miles (les Miles sont les points de fidélité obtenus en jouant au poker et en effectuant des paris sportifs). Pour obtenir 1€ de bonus, il vous suffit de cumuler 30 Miles. Ainsi, si vous avez déposé 100 € lors de votre premier dépôt, nous vous créditerons 20 € lorsque vous aurez atteint 600 Miles, puis 20 € supplémentaires quand vous aurez atteint 1200 Miles, etc. Au total vous aurez été crédité de 100 € supplémentaires lorsque vous aurez accumulé 3000 Miles.</p>\n<br />\n<p><small><i>*L’offre de premier dépôt n’est valable qu’une seule fois par utilisateur, terminal (ordinateur, tablette ou mobile), foyer ou compte bancaire. Elle est réservée aux joueurs n’ayant jamais effectué de dépôt sur un compte Winamax (y compris sur un compte qui a été fermé depuis). <a href=\"/winamax-mode-emploi_bonus_premier-depot\" target=\"_blank\">Voir toutes les conditions</a></i></small></p>\n</div>\n\n<div class=\"show-for-small-only\">\n<p>Pour fêter votre arrivée sur Winamax, profitez de deux offres de bienvenue lors de votre 1er dépôt : <b>le double de votre premier dépôt en Freebets jusqu’à 200 €</b> ! Ainsi qu'un <b>bonus allant jusqu'à 250 €</b>*.</p><br />\n\n<p>Les 2 offres sont cumulables et automatiquement déclenchées lors de votre premier dépôt, si vous en faites le choix.</p><br />\n\n<p>Alors, qu’attendez-vous pour rejoindre le site qui propose <b>le meilleur bonus de bienvenue ?</b></p><br />\n\n<p><small><i>*L’offre de premier dépôt n’est valable qu’une seule fois par utilisateur, terminal (ordinateur, tablette ou mobile), foyer ou compte bancaire. Elle est réservée aux joueurs n’ayant jamais effectué de dépôt sur un compte Winamax (y compris sur un compte qui a été fermé depuis). <a href=\"/winamax-mode-emploi_bonus_premier-depot\" target=\"_blank\">Voir toutes les conditions</a></i></small></p>\n</div>"
  ],
  "!desc:SpecialOfferLandingMobileContent": [
    null,
    "<h2>Comment ça marche ?</h2>\n<br />\n<p>Lors de votre tout premier dépôt sur Winamax, et avant n'importe quelle action de jeu, on vous offre le double de votre dépôt en Freebets jusqu’à 200 €.</p>\n\n<p>Par exemple, si vous déposez 100 € sur Winamax, vous recevrez immédiatement 200 € de Freebets sur votre compte et pourrez commencer à parier sur les différents sports. Les gains nets issus de Freebets sont versés en cash sur votre compte.</p>\n<br />\n<p>Nous vous offrons également un bonus d'une valeur égale à votre dépôt, dans la limite de 250 €. Nous créditerons votre compte Winamax par tranche de 20% de la valeur du bonus dès que vous aurez cumulé assez de Miles (les Miles sont les points de fidélité obtenus en jouant au poker et en effectuant des paris sportifs).Pour obtenir 1€ de bonus, il vous suffit de cumuler 30 Miles. Ainsi, si vous avez déposé 100 € lors de votre premier dépôt, nous vous créditerons 20 € lorsque vous aurez atteint 600 Miles, puis 20 € supplémentaires quand vous aurez atteint 1200 Miles, etc. Au total vous aurez été crédité de 100 € supplémentaires lorsque vous aurez accumulé 3000 Miles.</p>\n<br />\n<p><small><i>*L’offre de premier dépôt n’est valable qu’une seule fois par utilisateur, terminal (ordinateur, tablette ou mobile), foyer ou compte bancaire. Elle est réservée aux joueurs n’ayant jamais effectué de dépôt sur un compte Winamax (y compris sur un compte qui a été fermé depuis). <a href=\"/winamax-mode-emploi_bonus_premier-depot\" target=\"_blank\">Voir toutes les conditions</a></i></small></p>\n"
  ],
  "!placeholder:dd": [
    null,
    "jj"
  ],
  "!placeholder:mm": [
    null,
    "mm"
  ],
  "!placeholder:yy": [
    null,
    "aa"
  ],
  "!placeholder:yyyy": [
    null,
    "aaaa"
  ],
  ", if you lost": [
    null,
    ", si perdant"
  ],
  "1st bet refunded up to €100": [
    null,
    "Le double de ton premier dépôt offert, jusqu’à 200 €*"
  ],
  "A photo of the back of your ID document will also be required to validate your account.": [
    null,
    "Nous avons également besoin du VERSO pour les cartes d’identité ou les titres de séjour."
  ],
  "A receipt for your rent": [
    null,
    "Quittance de loyer"
  ],
  "Above": [
    null,
    "Au-delà de"
  ],
  "Acceptable ID": [
    null,
    "Les pièces d'identité acceptées"
  ],
  "Acceptable formats: %1$s.": [
    null,
    "Formats acceptés : %1$s."
  ],
  "Acceptable proof of address documents": [
    null,
    "Les justificatifs de domicile acceptés"
  ],
  "Account already exist": [
    null,
    "Il existe déjà un compte avec cet email/numéro de téléphone"
  ],
  "Account creation complete": [
    null,
    "Compte créé"
  ],
  "Account creation: complete.<br />That's what<br />we're talking about!": [
    null,
    "Compte créé,<br />c'est ça<br /> qu'on veut !"
  ],
  "Account number": [
    null,
    "Numéro de compte"
  ],
  "Activation code": [
    null,
    "Code d'activation"
  ],
  "Add a bank card": [
    null,
    "Ajouter une carte bancaire"
  ],
  "Add my bank card": [
    null,
    "J'ajoute ma CB"
  ],
  "Add my bank card details": [
    null,
    "Je saisis les infos de ma CB"
  ],
  "Address details": [
    null,
    "Complément d'adresse"
  ],
  "All countries": [
    null,
    "Tous les pays"
  ],
  "An error has occured when checking your CAPTCHA score. Please try again later.": [
    null,
    "Une erreur est survenue lors de la vérification de votre score CAPTCHA. Veuillez réessayer plus tard."
  ],
  "Analysis": [
    null,
    "Analyse"
  ],
  "Automatic withdrawal": [
    null,
    "Retrait automatique"
  ],
  "Automatic withdrawal threshold": [
    null,
    "Seuil de retrait auto"
  ],
  "BOOM! You can start playing!": [
    null,
    "ET bim ! Tu peux commencer à jouer !"
  ],
  "Back": [
    null,
    "Retour"
  ],
  "Back to homepage": [
    null,
    "Retour à l'accueil"
  ],
  "Bank": [
    null,
    "Banque"
  ],
  "Bank accounts from this country are not accepted on Winamax": [
    null,
    "Les comptes bancaires domiciliés dans ce pays ne sont pas acceptés sur Winamax"
  ],
  "Bank card number": [
    null,
    "Numéro de carte bancaire"
  ],
  "Bank code": [
    null,
    "Code banque"
  ],
  "Bank office": [
    null,
    "Code guichet"
  ],
  "Before any action even made on our site, we offer you your initial deposit in Freebets, up to €100.": [
    null,
    "Avant n'importe quelle action de jeu, on t'offre le montant ton dépôt initial en Freebets, jusqu'à 100€."
  ],
  "Beginner": [
    null,
    "Novice"
  ],
  "Beneficiary": [
    null,
    "Bénéficiaire"
  ],
  "Bet on sports": [
    null,
    "Parie sur le sport"
  ],
  "Betting limit - Poker": [
    null,
    "Limite de mises - Poker"
  ],
  "Betting limit - Sport betting": [
    null,
    "Limite de mises - Paris sportifs"
  ],
  "Birth date": [
    null,
    "Date de naissance"
  ],
  "Birth name": [
    null,
    "Nom de naissance"
  ],
  "Bonus up to €250": [
    null,
    "Bonus jusqu’à 250 €"
  ],
  "Boom!": [
    null,
    "Boom !"
  ],
  "By ticking this box, you agree that you have read and accepted our": [
    null,
    ""
  ],
  "CAPTCHA score error. Please try again. You will automatically be redirected to the Winamax website. (%1$s)": [
    null,
    "Erreur de score CAPTCHA. Nous t'invitons à réessayer. Tu vas automatiquement être redirigé vers le site Winamax. (%1$s)"
  ],
  "Card number": [
    null,
    "Numéro de carte"
  ],
  "Change address": [
    null,
    "Modifier l'adresse"
  ],
  "Change my deposit limit": [
    null,
    "Modifier ma limite de dépôt"
  ],
  "Change my limit": [
    null,
    "Je modifie ma limite"
  ],
  "Change your account details in order to receive your activation code by post.": [
    null,
    "Modifie tes coordonnées pour recevoir ton code d’activation par courrier postal."
  ],
  "Check that your bank card information is accurate and complete the cryptogram.": [
    null,
    "Vérifie que les informations de ta CB sont correctes et complète le cryptogramme."
  ],
  "Choose a deposit method in order to make your first deposit.": [
    null,
    "Pour effectuer ton premier dépôt, choisis un moyen de dépôt."
  ],
  "Choose a deposit method.": [
    null,
    "Choisis un moyen de dépôt."
  ],
  "Choose the amount of your first deposit in order to start playing.": [
    null,
    "Choisis le montant de ton premier dépôt pour commencer à jouer."
  ],
  "Choose the amount you wish to deposit in order to continue playing.": [
    null,
    "Choisis le montant de ton dépôt pour continuer à jouer."
  ],
  "Choose the maximum amount you wish to deposit per month.": [
    null,
    "Fixe le montant maximum que tu souhaites pouvoir déposer par mois."
  ],
  "Choose the maximum amount you wish to deposit per week.": [
    null,
    "Fixe le montant maximum que tu souhaites pouvoir déposer par semaine."
  ],
  "Choose the profile that best suits your playing style! You can also change the values manually.": [
    null,
    "Choisis le profil le plus adapté à ton style ! Tu peux aussi modifier les valeurs manuellement."
  ],
  "Choose which bank card you want to use to make a deposit.": [
    null,
    "Choisis la CB que tu veux utiliser pour faire ton dépôt."
  ],
  "Choose your country code": [
    null,
    "Sélectionne ton indicatif téléphonique"
  ],
  "Choose your limit well in order to take advantage of your <b>first bet refunded up to €100</b>": [
    null,
    "Choisis bien ta limite pour parier et jouer au poker."
  ],
  "Choose your username, but choose well!!<br />You need to have a kick-ass username to stand out in society.": [
    null,
    "Balance ton pseudo. Choisis bien !<br />C'est important d'avoir un nom qui claque pour briller en société."
  ],
  "City": [
    null,
    "Ville"
  ],
  "Click & drag your file here": [
    null,
    "Glisse et dépose ton fichier ici"
  ],
  "Close": [
    null,
    "Fermer"
  ],
  "Come and take a seat": [
    null,
    "Viens t'asseoir"
  ],
  "Complete registration now": [
    null,
    ""
  ],
  "Confirm limit": [
    null,
    "Je valide ma limite"
  ],
  "Confirm my details": [
    null,
    "Je valide mes coordonnées"
  ],
  "Confirm my limit": [
    null,
    "Je confirme ma limite"
  ],
  "Confirm your details in order to receive a new activation code by post.": [
    null,
    "Vérifie tes coordonnées pour recevoir un nouveau code d’activation par courrier postal."
  ],
  "Continue": [
    null,
    "Je continue"
  ],
  "Continue my deposit": [
    null,
    "Je continue mon dépôt"
  ],
  "Continue with PayPal": [
    null,
    "Continuer avec PayPal"
  ],
  "Country": [
    null,
    "Pays"
  ],
  "Country of birth": [
    null,
    "Pays de naissance"
  ],
  "Country of residence": [
    null,
    "Pays de résidence"
  ],
  "Create my account": [
    null,
    "Créer mon compte"
  ],
  "Creation": [
    null,
    "Création"
  ],
  "Cryptogram": [
    null,
    "Cryptogramme"
  ],
  "Deposit": [
    null,
    "Dépôt"
  ],
  "Deposit limit": [
    null,
    "Limite de dépôt"
  ],
  "Deposit on my account": [
    null,
    "Je crédite mon compte"
  ],
  "Deposit on your Winamax account by bank transfer": [
    null,
    "Crédite ton compte Winamax par virement bancaire"
  ],
  "Deposit on your account with Neteller.": [
    null,
    "Crédite ton compte par Neteller."
  ],
  "Deposit with Moneybookers/Skrill.": [
    null,
    "Crédite ton compte par Moneybookers/Skrill."
  ],
  "Document": [
    null,
    "Document"
  ],
  "Document number": [
    null,
    "Numéro de document"
  ],
  "Don't forget to send us your ID to validate your account and withdraw your winnings.": [
    null,
    ""
  ],
  "Driver's licence": [
    null,
    "Permis de conduire"
  ],
  "Driver's license": [
    null,
    "Permis de conduire"
  ],
  "Driver's license: whole document with photo or front and back sides": [
    null,
    "Permis de conduire : intégralité de la page avec photo"
  ],
  "Edit email/phone number": [
    null,
    "Je modifie mon email/numéro de téléphone"
  ],
  "Email": [
    null,
    "Email"
  ],
  "Enter a different amount": [
    null,
    "Je saisis un autre montant"
  ],
  "Enter amount": [
    null,
    "Je saisis le montant"
  ],
  "Enter my information": [
    null,
    "Je saisis mes infos"
  ],
  "Enter the activation code sent to you by post.": [
    null,
    "Entre le code d’activation que tu as reçu par courrier postal."
  ],
  "Enter the code sent by text message to %1$s to verify your phone number.": [
    null,
    "Entre le code que tu as reçu par SMS au %1$s pour vérifier ton numéro de téléphone."
  ],
  "Experienced": [
    null,
    "Confirmé"
  ],
  "Experienced profile token": [
    null,
    "Jeton de profil expérimenté"
  ],
  "Expiry date": [
    null,
    "Date d'expiration"
  ],
  "Feel free to discover the platform at a later date if you so wish.": [
    null,
    ""
  ],
  "Female": [
    null,
    "Femme"
  ],
  "Fill in my details": [
    null,
    "Compléter mes infos"
  ],
  "Fill out the following form. Or directly fill out the informations with Paypal": [
    null,
    "Complète le formulaire suivant. Ou remplis directement tes informations avec Paypal"
  ],
  "Fill out the form with your bank card information.": [
    null,
    "Complète le formulaire avec les infos de ta CB."
  ],
  "First deposit": [
    null,
    "Premier dépôt"
  ],
  "First name": [
    null,
    "Prénom"
  ],
  "For a Spanish nationality, you must supply us with a DNI and not a NIE": [
    null,
    "Pour une nationalité espagnole, vous devez nous fournir un DNI et non un NIE"
  ],
  "For a foreign nationality, you must supply us with a NIE and not a DNI": [
    null,
    "Pour une nationalité étrangère, vous devez nous fournir un NIE et non un DNI"
  ],
  "Free registration": [
    null,
    "Inscription gratuite"
  ],
  "Full name on card": [
    null,
    "Nom du titulaire"
  ],
  "GG!<br />Your account has<br />been validated!": [
    null,
    "Bien joué !<br />Ton compte<br />est validé !"
  ],
  "Gambling is prohibited for minors": [
    null,
    "Les jeux d’argent et de hasard \nsont interdits aux mineurs"
  ],
  "General Terms and Conditions": [
    null,
    "Conditions générales d'utilisation"
  ],
  "Health card: front and back": [
    null,
    ""
  ],
  "Hold on": [
    null,
    "Attends"
  ],
  "I accept the ": [
    null,
    "J'accepte les "
  ],
  "I agree to gain access to all": [
    null,
    ""
  ],
  "I have not received my code": [
    null,
    "Je n'ai pas reçu le code"
  ],
  "I need a new code": [
    null,
    "Je veux un nouveau code"
  ],
  "I want to receive offers and news": [
    null,
    ""
  ],
  "I will deposit later": [
    null,
    "Je déposerai plus tard"
  ],
  "I will send it at a later time": [
    null,
    "Je l'enverrai plus tard"
  ],
  "I would like to receive the newsletter and be kept up to date on all the latest bonuses and promotions": [
    null,
    ""
  ],
  "IBAN": [
    null,
    "Iban"
  ],
  "ID card: front and back": [
    null,
    "Carte d'identité : Recto verso "
  ],
  "ID card: front side": [
    null,
    "Carte d’identité : recto"
  ],
  "Identity card": [
    null,
    "Carte d'identité"
  ],
  "Identity not verified": [
    null,
    "Identité non valide"
  ],
  "If you are not resident in Germany, you can register on": [
    null,
    ""
  ],
  "Important! Make sure you add the folloing reference for your transfer:": [
    null,
    "Important ! Précise la référence suivante pour ton virement :"
  ],
  "In 30 seconds": [
    null,
    "En 30 secondes"
  ],
  "In order to be able to play for real money, you must submit an ID and proof of address.": [
    null,
    ""
  ],
  "In order to make your deposit, add your bank card or any other deposit method.": [
    null,
    "Pour effectuer ton dépôt, ajoute ta CB ou choisis un autre moyen de dépôt."
  ],
  "In order to make your first deposit, add your bank card or any other deposit method.": [
    null,
    "Pour effectuer ton premier dépôt, ajoute ta CB ou choisis un autre moyen de dépôt."
  ],
  "In order to play for real money, you must send us a proof of address.": [
    null,
    ""
  ],
  "In order to play for real money, you must send us an ID.": [
    null,
    ""
  ],
  "In order to validate your account, you must upload a photo of your ID.": [
    null,
    "Pour valider ton compte, tu dois ajouter une photo de ta pièce d'identité."
  ],
  "Incorrect format in this field": [
    null,
    "Le format de ce champ est incorrect."
  ],
  "Incorrect tax code": [
    null,
    "Code fiscal incorrect"
  ],
  "Incorrect value in this field, the department does not match the city.": [
    null,
    "Champ incorrect, le département renseigné n'est pas celui de la ville saisie."
  ],
  "Invalid NIE support number format. This must start with the letter \"E\" or \"C\" and be followed by 8 numbers.": [
    null,
    "Format de NIE support number invalide. Il doit commencer par un E ou un C et être suivi de 8 chiffres."
  ],
  "Invalid phone number format.": [
    null,
    "Le format du numéro de téléphone est incorrect."
  ],
  "It seems there is a connection problem": [
    null,
    "Il semblerait qu'il y ait un problème de connexion"
  ],
  "It's time to get serious": [
    null,
    ""
  ],
  "Join Winamax and take advantage of our welcome offer!": [
    null,
    "Rejoignez Winamax et profitez de notre offre de bienvenue !"
  ],
  "Keep an <br />eye on your<br />dough!": [
    null,
    "Garde un<br />oeil sur ta<br />thune !"
  ],
  "Last name": [
    null,
    "Nom"
  ],
  "Last<br />sprint!": [
    null,
    "Dernière<br />ligne<br />droite !"
  ],
  "Leave": [
    null,
    "Quitter"
  ],
  "Loading...": [
    null,
    "Chargement..."
  ],
  "Log in": [
    null,
    "Se connecter"
  ],
  "Make a deposit": [
    null,
    "Effectue un dépôt"
  ],
  "Male": [
    null,
    "Homme"
  ],
  "Maximum amount per month": [
    null,
    "Montant maximum par mois"
  ],
  "Maximum amount per week": [
    null,
    "Montant maximum par semaine"
  ],
  "Missing application initialization parameters. Please try again.": [
    null,
    "Impossible d'initialiser l'application. Veuillez réessayer."
  ],
  "Moneybookers email": [
    null,
    "Email Moneybookers"
  ],
  "Must contain at least 3 of the following characters: (0-9), (a-z), (A-Z) and symbols (ex @, !, #, $).": [
    null,
    ""
  ],
  "NIE number": [
    null,
    "NIE support number"
  ],
  "Nationality": [
    null,
    "Nationalité"
  ],
  "Neteller Secure ID": [
    null,
    "Neteller Secure ID"
  ],
  "Neteller account": [
    null,
    "Compte Neteller"
  ],
  "No godfather found for this code": [
    null,
    "Aucun parrain trouvé pour ce code"
  ],
  "No minors": [
    null,
    "Interdit aux mineurs"
  ],
  "Not connected": [
    null,
    "Non connecté"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Oops,": [
    null,
    "Oups,"
  ],
  "Open your account": [
    null,
    "Création de compte"
  ],
  "Optional": [
    null,
    "Facultatif"
  ],
  "Other deposit methods": [
    null,
    "Autres moyens de dépôt"
  ],
  "Other suggestions": [
    null,
    "Autres suggestions"
  ],
  "Our bank details for your transfer:": [
    null,
    "Voici nos coordonnées bancaires pour effectuer ton virement :"
  ],
  "Passport": [
    null,
    "Passeport"
  ],
  "Passport: whole page with photo": [
    null,
    "Passeport : intégralité de la page avec photo"
  ],
  "Password": [
    null,
    "Mot de passe"
  ],
  "Per month": [
    null,
    "Par mois"
  ],
  "Per week": [
    null,
    "Par semaine"
  ],
  "Personal information": [
    null,
    "Infos personnelles"
  ],
  "Phone number": [
    null,
    "Numéro de téléphone"
  ],
  "Phone, internet, water, gas or electricity bills": [
    null,
    "Facture de téléphone, d’internet, d’eau, de gaz ou d’électricité"
  ],
  "Place of birth": [
    null,
    "Ville de naissance"
  ],
  "Play on the app !": [
    null,
    "Joue sur l'app !"
  ],
  "Play poker": [
    null,
    "Joue au poker"
  ],
  "Play time - Poker": [
    null,
    "Temps de jeu - Poker"
  ],
  "Poker Terms and Conditions": [
    null,
    "Règlement poker"
  ],
  "Postal address": [
    null,
    "Adresse postale"
  ],
  "Postal code": [
    null,
    "Code postal"
  ],
  "Privacy Policy": [
    null,
    "Politique de confidentialité"
  ],
  "Processing": [
    null,
    "Upload"
  ],
  "Protect your behind!": [
    null,
    "Protège tes arrières !"
  ],
  "Protect<br />your<br />behind!": [
    null,
    "Protège<br />tes<br />arrières !"
  ],
  "Province": [
    null,
    "Province"
  ],
  "RIB key": [
    null,
    "Clé RIB"
  ],
  "Reference": [
    null,
    "Référence"
  ],
  "Referral": [
    null,
    "Ton parrain"
  ],
  "Referral code": [
    null,
    "Code parrainage"
  ],
  "Region of birth": [
    null,
    "Département de naissance"
  ],
  "Register": [
    null,
    "S'inscrire"
  ],
  "Register with my email": [
    null,
    "S'inscrire avec mon email"
  ],
  "Register with my phone number": [
    null,
    "S'inscrire avec mon numéro de téléphone"
  ],
  "Registration": [
    null,
    "Inscription"
  ],
  "Registration complete!": [
    null,
    "Inscription terminée !"
  ],
  "Registration not allowed from this country of residence.": [
    null,
    "Inscription non autorisée depuis ce pays de résidence."
  ],
  "Regular": [
    null,
    "Amateur"
  ],
  "Residence permit: front and back": [
    null,
    "Titre de séjour : recto et verso"
  ],
  "Responsible gaming": [
    null,
    "Jeu responsable"
  ],
  "SWIFT code": [
    null,
    "Swift"
  ],
  "Save this card for future deposits": [
    null,
    "Mémoriser cette carte pour un prochain dépôt"
  ],
  "Scan my ID": [
    null,
    "Je scanne ma pièce d'identité"
  ],
  "Scan my bank card": [
    null,
    "Je scanne ma CB"
  ],
  "Scan my verification document": [
    null,
    "Je scanne mon justificatif"
  ],
  "Search": [
    null,
    "Rechercher"
  ],
  "See Ts&Cs for the offer": [
    null,
    "Voir les conditions de l'offre"
  ],
  "See accepted verification documents": [
    null,
    "Voir les types de justificatifs"
  ],
  "See what IDs we accept": [
    null,
    "Voir les types de pièces d'identité"
  ],
  "Select your file": [
    null,
    "Sélectionne ton fichier"
  ],
  "Send ID": [
    null,
    ""
  ],
  "Send back of document": [
    null,
    "J'ajoute le verso"
  ],
  "Send documents": [
    null,
    ""
  ],
  "Send my ID": [
    null,
    "J'envoie ma pièce d'identité"
  ],
  "Send my new code": [
    null,
    "Je reçois un nouveau code"
  ],
  "Send my verification documents": [
    null,
    "J'envoie mes pièces justificatives"
  ],
  "Send proof of identity": [
    null,
    ""
  ],
  "Sex": [
    null,
    "Sexe"
  ],
  "Show<br />us who<br />you are!": [
    null,
    "Montre-<br />nous qui<br />tu es !"
  ],
  "Skip this step": [
    null,
    "Je passe cette étape"
  ],
  "Skrill email": [
    null,
    "Email Skrill"
  ],
  "Social security card": [
    null,
    "Carte sécurité sociale"
  ],
  "Sports betting Terms and Conditions": [
    null,
    "Règlement des paris sportifs"
  ],
  "Starting at €%1$s": [
    null,
    "À partir de %1$s €"
  ],
  "Successfully uploaded!": [
    null,
    "Bien uploadé !"
  ],
  "Super-player created!": [
    null,
    "Super joueur créé !"
  ],
  "Surname": [
    null,
    "Deuxième Nom"
  ],
  "Take 2 minutes to create your account.": [
    null,
    "Prends 2 minutes pour créer ton compte."
  ],
  "Tax Code": [
    null,
    "Code Fiscal"
  ],
  "Tax bill or home insurance letter": [
    null,
    "Avis d’imposition"
  ],
  "Terms and Conditions": [
    null,
    "Règlement complet"
  ],
  "The activation code cannot be over %1$s characters.": [
    null,
    "Le code d'activation ne doit pas dépasser %1$s caractères."
  ],
  "The activation code is not valid.": [
    null,
    "Le code d'activation n'est pas valable."
  ],
  "The best odds are your odds": [
    null,
    "La bonne cote, c'est la tienne"
  ],
  "The current process seems to be slow. Try again.": [
    null,
    "L'opération en cours semble trop lente. Réessaye."
  ],
  "The identity verification service is unavailable. Please try again later.": [
    null,
    "Le service de vérification d'identité est indisponible. Veuillez réessayer plus tard."
  ],
  "The maximum amount of time (in hours) you can spend at the poker tables each week.": [
    null,
    "C’est le temps maximum (en heures) que tu pourras passer sur les tables de poker chaque semaine."
  ],
  "The maximum amount of your balance (bankroll) above which any additional winnings will be transferred directly to your bank account. Your account must be validated beforehand and we will need your bank details.": [
    null,
    "C’est le montant maximum de ton solde (bankroll) à partir duquel chaque gain supplémentaire sera directement viré vers ton compte bancaire. Ton compte devra être validé au préalable et on aura besoin de ton RIB."
  ],
  "The maximum amount you can deposit into your account each week for sports betting and poker.": [
    null,
    "C’est le montant maximum que tu peux déposer sur ton compte chaque semaine pour les paris sportifs et le poker."
  ],
  "The maximum cumulative amount you can bet on poker each week.": [
    null,
    "C’est le montant de mises cumulées maximum que tu pourras jouer au poker chaque semaine."
  ],
  "The maximum cumulative amount you can bet on sports betting each week.": [
    null,
    "C’est le montant de mises cumulées maximum que tu pourras engager sur les paris sportifs chaque semaine."
  ],
  "The welcome bonus is linked to your first deposit. Set an amount of €100 (or more) to maximise your bonus!": [
    null,
    "L'offre de bienvenue est liée à ton 1er dépôt. Fixe un montant de 100 € (ou plus) pour optimiser au max !"
  ],
  "There already exists an account with this email address.": [
    null,
    "Il existe déjà un compte avec cette adresse email."
  ],
  "These deposit methods are not available for this amount.": [
    null,
    "Ces moyens de dépôt ne sont pas disponibles pour ce montant."
  ],
  "This code is required to create your account.": [
    null,
    "Ce code est obligatoire pour la création de ton compte."
  ],
  "This field is mandatory to validate your deposit.": [
    null,
    "Ce champ est obligatoire pour valider ton dépôt."
  ],
  "This file format is invalid. Please try in one of the following formats: %1$s.": [
    null,
    "Ce format de fichier n'est pas accepté. Réessaye avec un format : %1$s."
  ],
  "This fiscal code is already linked to an active account": [
    null,
    "Ce code fiscal est déjà lié à un compte actif"
  ],
  "This limit can be changed at any time in your account.": [
    null,
    "Cette limite est modifiable à tout moment dans ton compte."
  ],
  "This limit is mandatory for your account validation.": [
    null,
    "Ce seuil est obligatoire pour l’activation de ton compte."
  ],
  "This password does not contain at least 3 of the following: (0-9), (a-z), (A-Z) and symbols (e.g. @, !, #, $)": [
    null,
    "Ce mot de passe ne contient pas au moins 3 des types suivants : (0-9), (a-z), (A-Z) et symboles (ex @, !, #, $)"
  ],
  "This referral code is not valid.": [
    null,
    "Ce code parrainage n'est pas valide"
  ],
  "This threshold can be changed at any time from your account.": [
    null,
    "Ce seuil est modifiable à tout moment dans ton compte."
  ],
  "This username is unavailable.": [
    null,
    "Ce pseudo n'est pas disponible."
  ],
  "This way for<br />money": [
    null,
    "Par ici la<br />monnaie"
  ],
  "Too many attempts with this identity. Please try again later.": [
    null,
    "Vous avez fait trop de tentatives avec une identité erronée. Veuillez réessayer plus tard."
  ],
  "Try again": [
    null,
    "Je réessaye"
  ],
  "Ts&Cs": [
    null,
    "CGU"
  ],
  "Ts&Cs for the offer": [
    null,
    "Conditions de l’offre"
  ],
  "Type of cash-out": [
    null,
    "Type de retrait"
  ],
  "Type of document": [
    null,
    "Type de document"
  ],
  "Unable to load profile information.": [
    null,
    "Le chargement des informations liées à votre compte a échoué. "
  ],
  "Unable to send verification message.": [
    null,
    "L'envoie du code de vérification n'a pas fonctionné."
  ],
  "Unauthorised email.": [
    null,
    "Ton e-mail n'est pas autorisé."
  ],
  "Up to": [
    null,
    "Jusqu'à"
  ],
  "Up to a limit of €100 or the same amount as your first deposit": [
    null,
    "Dans la limite de 100 € ou du montant de ton premier dépôt"
  ],
  "Up to €100 free, instantly!": [
    null,
    "Jusqu'à 100€ offerts direct !"
  ],
  "Upload an identity document to continue registration.": [
    null,
    "Ajoute un document d’identité afin de poursuivre l’inscription."
  ],
  "Upload my ID": [
    null,
    "J'ajoute ma pièce d'identité"
  ],
  "Upload my verification document": [
    null,
    "J'envoie mon justificatif"
  ],
  "Use France Connect": [
    null,
    "J'utilise France Connect"
  ],
  "Use my existing deposit limit. If none is available, the limit set by you above will be applied.": [
    null,
    "Je veux utiliser ma limite de dépôt déjà existante sur les autres sites ; si elle est inexistante on utilisera la limite que tu as mis ci-dessus."
  ],
  "Used or married name": [
    null,
    "Nom d’usage ou marital"
  ],
  "Username": [
    null,
    "Pseudo"
  ],
  "Validate": [
    null,
    "Je valide"
  ],
  "Validate my deposit": [
    null,
    "Je valide mon dépôt"
  ],
  "Validate my information": [
    null,
    "Je valide mes infos"
  ],
  "Validate my limit": [
    null,
    "Je valide mon seuil"
  ],
  "Validate my username": [
    null,
    "Je valide mon pseudo"
  ],
  "Validation code": [
    null,
    "Code de vérification"
  ],
  "Verification": [
    null,
    "Vérification"
  ],
  "Verify your phone number to receive a new text message with your validation code.": [
    null,
    "Vérifie ton numéro de téléphone pour recevoir un nouveau code de vérification par SMS."
  ],
  "Want to start playing? Make a deposit now.": [
    null,
    ""
  ],
  "Want to<br />create a<br />username?": [
    null,
    "Tu veux te<br />faire un<br />nom ?"
  ],
  "We are also offering a bonus of equal value to your first deposit.": [
    null,
    "On t'offre aussi un bonus d'une valeur égale au montant de ton premier dépôt."
  ],
  "We cannot accept land-line numbers.": [
    null,
    "Les numéros de téléphone fixe ne sont pas acceptés."
  ],
  "We will refund your 1st bet up to €100.": [
    null,
    "Avant n'importe quelle action de jeu, on t’offre le double de ton dépôt initial en Freebets, jusqu’à 200 €."
  ],
  "We're fetching your data...": [
    null,
    "On récupère tes données..."
  ],
  "Weekly betting limits": [
    null,
    "Limites de jeu par semaine"
  ],
  "Welcome bonus": [
    null,
    "Offre de bienvenue"
  ],
  "Welcome to Winamax": [
    null,
    "Bienvenue sur Winamax"
  ],
  "Welcome<br />to<br />Winamax!": [
    null,
    "Bienvenue<br />sur<br />Winamax !"
  ],
  "What is France Connect": [
    null,
    "Qu'est-ce que France Connect"
  ],
  "With 168h per week, you can play for an unlimited period": [
    null,
    "Avec 168h par semaine, tu peux jouer en illimité"
  ],
  "Withdrawable cash credited to your account directly after the result of the first bet": [
    null,
    "Cash retirable crédité sur ton compte directement après le résultat du premier pari"
  ],
  "You are already registered.": [
    null,
    "Vous êtes déjà inscrit."
  ],
  "You are not authorized to access this service.": [
    null,
    "L'accès à ce service n'est pas autorisé."
  ],
  "You are not permitted to create an account from this country.": [
    null,
    "Il n'est pas autorisé de créer un compte depuis ce pays."
  ],
  "You are not permitted to create this user account.": [
    null,
    "Vous n'êtes pas autorisé à créer un compte."
  ],
  "You are on the Interior Ministry's banned player list!": [
    null,
    "Vous figurez sur la liste des interdits de jeux du ministère de l'intérieur."
  ],
  "You can change this option at any time from your account": [
    null,
    ""
  ],
  "You can continue playing on Winamax in the meantime.": [
    null,
    "En attendant, tu peux continuer à jouer sur Winamax."
  ],
  "You can finally risk it for that big accumulator!": [
    null,
    "Profites-en pour tenter la grosse cote !"
  ],
  "You can only upload one file at a time. Choose wisely!": [
    null,
    "Tu ne peux mettre qu'un seul fichier. Choisis le bon !"
  ],
  "You can send this to us at a later time, but you must enter your information now.": [
    null,
    "Tu peux nous l'envoyer plus tard, mais tu dois saisir tes infos maintenant."
  ],
  "You cannot create an account from your country.": [
    null,
    "Vous ne pouvez pas créer de compte depuis votre pays."
  ],
  "You have already transferred this file.": [
    null,
    "Vous aviez déjà transféré ce fichier."
  ],
  "You have entered an invalid domiciliation code": [
    null,
    "Le code d'activation est incorrect."
  ],
  "You have entered an invalid phone number.": [
    null,
    "Ton numéro de téléphone n'est pas valable."
  ],
  "You have insufficient CAPTCHA score to continue. Please try again later.": [
    null,
    "Votre score CAPTCHA est insuffisant pour continuer. Veuillez réessayer plus tard. "
  ],
  "You have successfully added your identity document. Please ensure the information you have entered is correct and fill out your postal address.": [
    null,
    "Ta pièce d'identité a été scannée avec succès. Vérifie que tes infos sont correctes et complète ton adresse postale."
  ],
  "You have successfully made a request to change your password. Please check your emails.": [
    null,
    "Vous avez fait une demande de changement de mot de passe. Vérifiez vos emails."
  ],
  "You must accept our Ts&Cs in order to create your account.": [
    null,
    "Accepter les CGU est obligatoire pour te créer un compte."
  ],
  "You must choose a betting stakes limit in order to start playing.": [
    null,
    "Tu dois saisir ta limite de mises pour les paris sportifs pour pouvoir commencer à jouer."
  ],
  "You must choose a deposit limit in order to make a deposit.": [
    null,
    "Ta limite de dépôt est obligatoire pour renflouer tes caisses."
  ],
  "You must choose a password.": [
    null,
    "Tu dois entrer un mot de passe."
  ],
  "You must choose a playtime limit in order to start playing.": [
    null,
    "Tu dois saisir ta limite de temps de jeu poker pour pouvoir commencer à jouer."
  ],
  "You must choose a poker stakes limit in order to start playing.": [
    null,
    "Tu dois saisir ta limite de mises pour le poker pour pouvoir commencer à jouer."
  ],
  "You must choose an automatic withdrawal limit in order to start playing.": [
    null,
    "Tu dois saisir ta limite de retrait automatique pour pouvoir commencer à jouer."
  ],
  "You must choose an option for your sex in order to create your account.": [
    null,
    "Le choix du sexe est obligatoire pour la création de ton compte."
  ],
  "You must enter a deposit amount.": [
    null,
    "Tu dois entrer un montant de dépôt."
  ],
  "You must enter an email or a phone number.": [
    null,
    "Tu dois entrer un email ou un numéro de téléphone."
  ],
  "You must enter the full name displayed on your bank card in order to validate your deposit.": [
    null,
    "Le nom du titulaire de ta carte bancaire est obligatoire pour valider ton dépôt."
  ],
  "You must enter your activation code in order to validate your account.": [
    null,
    "Le code d'activation est obligatoire pour l'activation de ton compte."
  ],
  "You must enter your bank card cryptogram in order to validate your deposit.": [
    null,
    "Le cryptogramme de ta carte bancaire est obligatoire pour valider ton dépôt."
  ],
  "You must enter your bank card expiry date in order to validate your deposit.": [
    null,
    "La date d'expiration de ta carte bancaire est obligatoire pour valider ton dépôt."
  ],
  "You must enter your bank card number in order to validate your deposit.": [
    null,
    "Ton numéro de carte bancaire est obligatoire pour valider ton dépôt."
  ],
  "You must enter your city of birth in order to create your account.": [
    null,
    "Ta ville de naissance est obligatoire pour la création de ton compte."
  ],
  "You must enter your city of residence in order to create your account.": [
    null,
    "Ta ville est obligatoire pour la création de ton compte."
  ],
  "You must enter your country of birth in order to create your account.": [
    null,
    "Ton pays de naissance est obligatoire pour la création de ton compte."
  ],
  "You must enter your country of residence in order to create your account.": [
    null,
    "Ton pays est obligatoire pour la création de ton compte."
  ],
  "You must enter your date of birth in order to create your account.": [
    null,
    "Ta date de naissance est obligatoire pour la création de ton compte."
  ],
  "You must enter your department of birth in order to create your account.": [
    null,
    "Ton département de naissance est obligatoire pour la création de ton compte."
  ],
  "You must enter your email in order to create your account.": [
    null,
    "Ton email est obligatoire pour la création de ton compte."
  ],
  "You must enter your phone number in order to create your account.": [
    null,
    "Ton numéro de téléphone est obligatoire pour la création de ton compte."
  ],
  "You must enter your postal address in order to create your account.": [
    null,
    "Ton adresse postale est obligatoire pour la création de ton compte."
  ],
  "You must enter your postal code in order to create your account.": [
    null,
    "Ton code postal est obligatoire pour la création de ton compte."
  ],
  "You must enter your province to create your account.": [
    null,
    ""
  ],
  "You must not be connected to the Winamax Poker software (desktop or mobile)": [
    null,
    "Vous ne devez pas être connecté sur le logiciel de Poker Winamax (ordinateur, mobile et tablette)"
  ],
  "You must provide your first name in order to create your account.": [
    null,
    "Ton prénom est obligatoire pour la création de ton compte."
  ],
  "You must provide your last name in order to create your account.": [
    null,
    "Ton nom est obligatoire pour la création de ton compte."
  ],
  "You must provide your second last name in order to create your account.": [
    null,
    ""
  ],
  "You need a username to play on Winamax.": [
    null,
    "Il te faut un pseudo pour jouer sur Winamax."
  ],
  "You need to provide us with your ID and proof of address in order to complete your registration.": [
    null,
    "Il manque ta pièce d'identité et ton justificatif de domicile pour compléter ton inscription."
  ],
  "You need to provide us with your ID in order to complete your registration.": [
    null,
    "Il manque ta pièce d'identité pour compléter ton inscription."
  ],
  "You will receive an activation code by post at the following address:": [
    null,
    "Tu vas recevoir un code d'activation par courrier postal, à cette adresse :"
  ],
  "You're too old!": [
    null,
    "T'es trop vieux !"
  ],
  "You're too young!": [
    null,
    "T’es trop jeune !"
  ],
  "You're way too young!": [
    null,
    "T'es trop jeune !"
  ],
  "Your ID could not be analyzed but it has been registered. Please enter your information whilst waiting for your document to be verified.": [
    null,
    "Ta pièce d’identité n’a pas pu être analysée mais elle est enregistrée. Saisis tes infos en attendant qu’elle soit validée."
  ],
  "Your ID upload has encountered an error": [
    null,
    "Le téléchargement de ta pièce d'identité n'a pas fonctionné"
  ],
  "Your ID was registered successfully": [
    null,
    "Votre pièce d’identité a bien été enregistrée"
  ],
  "Your account is frozen.": [
    null,
    "Votre compte est verrouillé."
  ],
  "Your account is reloaded,<br /><b>you can continue playing on Winamax</b>": [
    null,
    "Tes caisses sont renflouées,<br /><b>tu peux continuer à jouer sur Winamax</b>"
  ],
  "Your account validation is being processed. You will be notified when your documents have been validated.": [
    null,
    "Ton compte est en cours de validation. Tu recevras une notification une fois tes documents validés."
  ],
  "Your address is not valid.": [
    null,
    "Votre adresse est incorrect."
  ],
  "Your automatic withdrawal limit cannot be over %1$s digits.": [
    null,
    "Ton seuil de retrait automatique ne doit pas dépasser %1$s chiffres."
  ],
  "Your automatic withdrawal limit is too big.": [
    null,
    "Ton seuil de retrait automatique est trop grand."
  ],
  "Your automatic withdrawal limit must be greater than or equal to your deposit limit.": [
    null,
    "Ton seuil de retrait doit être supérieur ou égal à ta limite de dépôt."
  ],
  "Your automatic withdrawal limit must be more than €200.": [
    null,
    "Cette valeur ne peut pas être inférieure à 200 €."
  ],
  "Your automatic withdrawal limit must be over €0.": [
    null,
    "Ton seuil de retrait automatique doit être supérieur à 0 €."
  ],
  "Your bank card cryptogram is not valid.": [
    null,
    "Le cryptogramme de ta carte bancaire n'est pas valable."
  ],
  "Your bank card expiry date is not valid.": [
    null,
    "La date d'expiration de ta carte bancaire n'est pas valable."
  ],
  "Your bank card number is not valid": [
    null,
    "Ton numéro de carte bancaire n'est pas valable."
  ],
  "Your bet refunded in": [
    null,
    "Profite d'un pari remboursé"
  ],
  "Your betting stakes limit is too big.": [
    null,
    "Ta limite de mise est trop grande."
  ],
  "Your betting stakes limit must be more than €0.": [
    null,
    "Tu ne pourras pas parier."
  ],
  "Your betting stakes limit per week is not valid.": [
    null,
    "Votre modérateur de mise par semaine pour les paris sportifs est incorrect."
  ],
  "Your city cannot be over %1$s characters.": [
    null,
    "Ta ville ne doit pas dépasser %1$s caractères."
  ],
  "Your city is not valid.": [
    null,
    "Ta ville n'est pas valable."
  ],
  "Your city is required.": [
    null,
    "Ta ville est obligatoire."
  ],
  "Your city of birth cannot be over %1$s characters.": [
    null,
    "Ta ville de naissance ne doit pas dépasser %1$s caractères."
  ],
  "Your city of birth is not valid.": [
    null,
    "Ta ville de naissance n'est pas valable."
  ],
  "Your coordinates": [
    null,
    "Tes coordonnées"
  ],
  "Your country cannot be over %1$s characters.": [
    null,
    "Ton pays ne doit pas dépasser %1$s caractères."
  ],
  "Your country is not valid.": [
    null,
    "Ton pays n'est pas valable."
  ],
  "Your country is required.": [
    null,
    "Ton pays est obligatoire."
  ],
  "Your country of birth is not valid.": [
    null,
    "Ton pays de naissance n'est pas valable."
  ],
  "Your date of birth is not valid.": [
    null,
    "Ta date de naissance n'est pas valable."
  ],
  "Your date of birth must include 4 numbers.": [
    null,
    "Ton année de naissance doit comporter 4 chiffres."
  ],
  "Your department of birth cannot be over %1$s characters.": [
    null,
    "Ton département de naissance ne doit pas dépasser %1$s caractères."
  ],
  "Your department of birth is not valid.": [
    null,
    "Ton département de naissance n'est pas valable."
  ],
  "Your deposit cannot be more than your weekly deposit limit: €%1$s.": [
    null,
    "Ton dépôt ne doit pas dépasser ta limite de dépôt par semaine : %1$s €."
  ],
  "Your deposit limit has been registered. <b>in 48 hours, you will be able to make larger deposits</b>": [
    null,
    "Ta limite de dépôt a été prise en compte. <b>dans 48H, tu pourras faire un dépôt plus important</b>"
  ],
  "Your deposit limit is too big.": [
    null,
    "Ta limite de dépôt est trop grande."
  ],
  "Your deposit limit must be more than €0.": [
    null,
    "Ta limite de dépôt doit être supérieure à 0 €."
  ],
  "Your deposit limit per week is not valid.": [
    null,
    "Votre modérateur de dépôt par semaine est incorrect."
  ],
  "Your deposit must be over €0.": [
    null,
    "Ton dépôt doit être supérieur à 0 €."
  ],
  "Your document failed to upload": [
    null,
    "Le téléchargement de ta pièce justificative n'a pas fonctionné"
  ],
  "Your email cannot be over %1$s characters.": [
    null,
    "Ton email ne doit pas dépasser %1$s caractères."
  ],
  "Your email is not valid.": [
    null,
    "Ton email n'est pas valable."
  ],
  "Your file is too big. Try again with a file smaller than %1$s Mb.": [
    null,
    "Ton fichier est trop lourd. Réessaye avec un fichier de %1$s Mo max."
  ],
  "Your first bet refunded in cash if it loses": [
    null,
    "Ton premier pari remboursé en cash s'il est perdant"
  ],
  "Your first name cannot be over %1$s characters.": [
    null,
    "Ton prénom ne doit pas dépasser %1$s caractères."
  ],
  "Your first name is not valid.": [
    null,
    "Ton prénom n'est pas valable."
  ],
  "Your identity": [
    null,
    "Votre identité"
  ],
  "Your identity corresponds to that of a minor.": [
    null,
    "Votre identité correspond à celle d'une personne mineure."
  ],
  "Your identity corresponds to that of someone who has been registered as being deceased.": [
    null,
    "Votre identité correspond à celle d'une personne enregistrée comme décédée."
  ],
  "Your information is being processed!": [
    null,
    "Tes infos sont en cours d'envoi !"
  ],
  "Your initial deposit in Freebets, up to €100*": [
    null,
    "Le montant de ton premier dépôt directement offert en Freebets, jusqu'à 100€*"
  ],
  "Your last name cannot be over %1$s characters.": [
    null,
    "Ton nom ne doit pas dépasser %1$s caractères."
  ],
  "Your last name is not valid.": [
    null,
    "Ton nom n'est pas valable."
  ],
  "Your limit cannot be €0": [
    null,
    "La limite ne peut pas être égale à 0 €"
  ],
  "Your limit for %1$s must be inferior or equal to %2$s": [
    null,
    "Ta limite pour ton %1$s doit être inférieure ou égal à %2$s"
  ],
  "Your limit for %1$s must be set between %2$s and %3$s": [
    null,
    "Ta limite pour ton %1$s doit être comprise entre %2$s et %3$s"
  ],
  "Your limit for %1$s must be superior or equal to %2$s": [
    null,
    "Ta limite pour ton %1$s doit être supérieure ou égale à %2$s"
  ],
  "Your limit for %1$s must be superior or equal to your %2$s limit": [
    null,
    "Ta limite pour ton %1$s doit être supérieure ou égale à ta limite pour ta %2$s"
  ],
  "Your limit must be inferior or equal to %1$s": [
    null,
    "Ta limite doit être inférieure ou égale à %1$s"
  ],
  "Your limit must be set between %1$s and %2$s": [
    null,
    "Ta limite doit être comprise entre %1$s et %2$s"
  ],
  "Your limit must be superior or equal to %1$s": [
    null,
    "Ta limite doit être supérieure ou égale à %1$s"
  ],
  "Your name in the rankings will be:": [
    null,
    "Ton nom dans le classement sera :"
  ],
  "Your number will only be used to identify you": [
    null,
    "Ton numéro ne sera utilisé que pour t’identifier"
  ],
  "Your password cannot be over %1$s characters.": [
    null,
    "Ton mot de passe ne doit pas dépasser %1$s caractères."
  ],
  "Your password is not valid.": [
    null,
    "Ton mot de passe n'est pas valide."
  ],
  "Your password must contain at least %1$s characters.": [
    null,
    "Ton mot de passe doit faire au moins %1$s caractères."
  ],
  "Your payment": [
    null,
    "Ton paiement"
  ],
  "Your phone number is mandatory in order to receive a new code.": [
    null,
    "Ton numéro de téléphone est obligatoire pour recevoir un nouveau code."
  ],
  "Your playtime limit must be more than 0 hours.": [
    null,
    "Tu ne pourras pas jouer."
  ],
  "Your poker stakes limit is too big.": [
    null,
    "Ta limite de mise est trop grande."
  ],
  "Your poker stakes limit must be more than €0.": [
    null,
    "Tu ne pourras pas jouer."
  ],
  "Your poker stakes limit per week is not valid.": [
    null,
    "Votre modérateur de mise par semaine pour le poker est incorrect."
  ],
  "Your postal address cannot be over %1$s characters.": [
    null,
    "Ton adresse postale ne doit pas dépasser %1$s caractères."
  ],
  "Your postal address is required.": [
    null,
    "Ton adresse postale est obligatoire."
  ],
  "Your postal code cannot be over %1$s characters.": [
    null,
    "Ton code postal ne doit pas dépasser %1$s caractères."
  ],
  "Your postal code is required.": [
    null,
    "Ton code postal est obligatoire."
  ],
  "Your proof of address cannot be over one year old.": [
    null,
    "Votre justificatif doit dater de moins d’un an."
  ],
  "Your session has expired.": [
    null,
    "Votre session a expiré."
  ],
  "Your state is not valid.": [
    null,
    "Votre état est incorrect."
  ],
  "Your story begins here!": [
    null,
    "Ton histoire commence ici !"
  ],
  "Your turn to play": [
    null,
    "À toi de jouer"
  ],
  "Your turn<br />to play": [
    null,
    "À toi<br />de jouer"
  ],
  "Your username cannot contain over %1$s characters.": [
    null,
    "Ton pseudo ne doit pas dépasser %1$s caractères."
  ],
  "Your username is not valid, the only authorized special characters are: .&_- and space.": [
    null,
    "Ton pseudo n'est pas valable, les seuls caractères spéciaux autorisés sont : .&_- et l'espace."
  ],
  "Your username must contain at least %1$s characters.": [
    null,
    "Ton pseudo doit faire au moins %1$s caractères."
  ],
  "Your validation code is incorrect.": [
    null,
    "Votre code de validation est incorrect."
  ],
  "Your zip code is not valid.": [
    null,
    "Votre code postal est incorrect."
  ],
  "Your zip code of birth is not valid.": [
    null,
    "Votre département de naissance est incorrect."
  ],
  "and": [
    null,
    ""
  ],
  "as well as our": [
    null,
    ""
  ],
  "is being processed...": [
    null,
    "est en cours de traitement..."
  ],
  "of a super-player in progress...": [
    null,
    "d'un super joueur en cours..."
  ],
  "of the ongoing payment...": [
    null,
    "du paiement en cours..."
  ],
  "of your bank card processing...": [
    null,
    "de ta CB en cours..."
  ],
  "or": [
    null,
    "ou"
  ],
  "poker": [
    null,
    ""
  ],
  "promotions": [
    null,
    ""
  ],
  "sports betting": [
    null,
    ""
  ],
  "your document upload...": [
    null,
    "de ton document en cours..."
  ]
}
  }
}
